import BaseRepository from './base.repository';

class AuthRepository extends BaseRepository {
  constructor() {
    super('/auth');
  }

  getMe() {
    return this.client.get('/me');
  }

  updateProfile(payload, config = {}) {
    return this.client.patch('/me', payload, config);
  }
}

export default new AuthRepository();
